import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  background: #f0f0f5 !important;
  padding: 40px 0px !important;
  margin: 0px !important;

  ${media.xl`
    padding: 100px 0px !important;
  `}
`;

export const StyledContentBlock = styled.div`
  max-width: 1440px;
  padding: 0px !important;
  margin: auto;
`;

export const MainContainer = styled.div`
  padding: 0px 20px !important;

  ${media.md`
    padding: 0px 60px !important;
  `}

  ${media.xl`
    padding: 0px 80px !important;
  `}
`;

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

export const Title = styled.h2`
  color: #1c1c1c;
  font-family: 'Elza Condensed';
  font-size: 34px;
  font-weight: 500;
  line-height: 89%;
  letter-spacing: -0.68px;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;

  ${media.md`
    font-size: 60px;
    font-weight: 500;
    line-height: 90%;
    letter-spacing: -1.2px;
  `}

  ${media.xl`
    font-size: 70px;
    font-weight: 500;
    line-height: 85%;
    letter-spacing: -1.4px;
  `}
`;

export const Subtitle = styled.p`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium';
  font-size: 16px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.32px;
  text-align: center;
  margin: 0px;

  ${media.md`
    font-size: 24px;
    font-weight: 700;
    line-height: 110%;
    letter-spacing: -0.48px;
  `}
`;

export const LinksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 32px;

  ${media.md`
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    margin-top: 50px;
  `}
`;

export const LinkItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 12px;
  padding: 16px 12px;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease;

  &:hover {
    background: #e8e8ed;
    transform: translateY(-2px);
  }

  ${media.md`
    padding: 20px 16px;
    border-radius: 16px;
  `}
`;

export const LinkText = styled.span`
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium';
  font-size: 14px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.28px;
  text-align: center;

  ${media.md`
    font-size: 16px;
    letter-spacing: -0.32px;
  `}
`;

export const SeeMoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 2px solid #1c1c1c;
  border-radius: 12px;
  padding: 16px 24px;
  margin: 24px auto 0;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium';
  font-size: 14px;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.28px;

  &:hover {
    background: #1c1c1c;
    color: #ffffff;
  }

  ${media.md`
    padding: 20px 32px;
    border-radius: 16px;
    font-size: 16px;
    letter-spacing: -0.32px;
    margin-top: 32px;
  `}
`;
